// extracted by mini-css-extract-plugin
module.exports = {"eddContainer":"Status_eddContainer__ydyNz","clockIcon":"Status_clockIcon__zkbtw","statusText":"Status_statusText__1IQHt"};